const setupFooterMenuAccordions = () => {
  const accordionItems = document.querySelectorAll('.js-footer-menu-item');

  accordionItems?.forEach((item) => {
    const button = item.querySelector('.js-footer-menu-heading');

    // Clone the button to remove existing listeners
    const newButton = button.cloneNode(true);
    button.parentNode.replaceChild(newButton, button);

    newButton.addEventListener('click', function () {
      const isOpen = item.classList.contains('is-open');

      accordionItems.forEach((otherItem) => {
        otherItem.classList.remove('is-open');
      });

      if (!isOpen) {
        item.classList.add('is-open');
      }
    });
  });
};

export const initFooterMenuAccordions = () => {
  const handleResize = () => {
    if (window.innerWidth < 1024) {
      setupFooterMenuAccordions();
    }
  };

  handleResize(); // Run initially
  window.addEventListener('resize', handleResize);
};

export const initFooterCountrySelector = () => {
  const wrapper = document.querySelector('.localization-wrapper');
  const trigger = document.querySelector('.localization-trigger');
  const dropdownButtons = wrapper.querySelectorAll('.localization-option');

  // Make dropdown options unfocusable initially
  dropdownButtons.forEach((btn) => btn.setAttribute('tabindex', '-1'));

  function openDropdown() {
    wrapper.classList.add('open');
    dropdownButtons.forEach((btn) => btn.removeAttribute('tabindex'));
  }

  function closeDropdown() {
    wrapper.classList.remove('open');
    dropdownButtons.forEach((btn) => btn.setAttribute('tabindex', '-1'));
  }

  trigger.addEventListener('click', (e) => {
    e.stopPropagation();
    if (wrapper.classList.contains('open')) {
      closeDropdown();
    } else {
      openDropdown();
    }
  });

  document.addEventListener('click', (e) => {
    if (!wrapper.contains(e.target)) {
      closeDropdown();
    }
  });

  const footer = document.querySelector('footer');
  const stickyButton = document.querySelector('.sticky-button a');

  if (footer && stickyButton) {
    const focusableFooterEls = footer.querySelectorAll(
      'a[href], button, input, select, textarea, [tabindex]:not([tabindex="-1"])',
    );

    if (focusableFooterEls.length > 0) {
      const lastFooterEl = focusableFooterEls[focusableFooterEls.length - 1];

      lastFooterEl.addEventListener('keydown', (e) => {
        if (e.key === 'Tab' && !e.shiftKey) {
          e.preventDefault();
          stickyButton.focus();
        }
      });
    }
  }
};
